import { apiPost } from '../_common';

export default {
  generateShippingLabels(shipmentId, orderIds) {
    const request = {
      shipmentId,
      orderIds,
    };

    return apiPost('/magenta/fulfillment/smart-envios-shipping-label', request)
      .then(result => result.response);
  },
};
